import { Serializable } from '@/models/core/serializable';

export class ImportStudentResults implements Serializable<ImportStudentResults> {
  registrationCount?: number;
  updatedCount?: number;
  code?: number;
  reason?: string;

  deserialize(input: any): ImportStudentResults {
    this.registrationCount = input.registrationCount;
    this.updatedCount = input.updatedCount;
    this.code = input.code;
    this.reason = input.reason;
    return this;
  }
}
